'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mightyFields = require('../../lib/mighty-fields');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LeadSourceFormGroup = (_dec = (0, _mobxReact.inject)('OptionsStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(LeadSourceFormGroup, _Component);

  function LeadSourceFormGroup(props) {
    _classCallCheck(this, LeadSourceFormGroup);

    var _this = _possibleConstructorReturn(this, (LeadSourceFormGroup.__proto__ || Object.getPrototypeOf(LeadSourceFormGroup)).call(this, props));

    _initDefineProp(_this, 'isLoading', _descriptor, _this);

    _this.FIELD_SETS_FIELD_CATEGORY = {
      field: 'category',
      optionKey: 'value',
      optionType: 'leadSourceCategoryOptions',
      type: 'optionSelect'
    };

    _this.FIELD_SETS_FIELD_NAME = {
      createFields: [{ field: 'name', populateFromSearch: true, required: true }],
      editProps: {
        validationErrors: { isRequiredFor: 'Lead Source is required.' },
        validations: { isRequiredFor: 'category' }
      },
      field: 'name',
      getOptions: _this.getLeadSourceOptions,
      label: 'Lead Source',
      type: 'objectSearchCreate'
    };

    _this.formManager = new _utils.FormManager({
      fieldSets: [[_this.FIELD_SETS_FIELD_CATEGORY, _this.FIELD_SETS_FIELD_NAME]]
    });

    if (props.leadSource) {
      var _props$leadSource = props.leadSource,
          category = _props$leadSource.category,
          id = _props$leadSource.id,
          name = _props$leadSource.name;


      _this.onChangeCategory(category);
      _this.onChangeName({ id: id, name: name });
    }
    return _this;
  }

  _createClass(LeadSourceFormGroup, [{
    key: 'getLeadSourceOptions',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(search) {
        var fetchLeadSourceNameOptions, category;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fetchLeadSourceNameOptions = this.props.OptionsStore.fetchLeadSourceNameOptions, category = this.formManager.submitData.category;
                _context.next = 3;
                return fetchLeadSourceNameOptions(category, search);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLeadSourceOptions(_x) {
        return _ref.apply(this, arguments);
      }

      return getLeadSourceOptions;
    }()
  }, {
    key: 'onChange',
    value: function onChange() {
      var data = this.formManager.submitData;
      this.props.onChange({
        category: (0, _get3.default)(data, 'category'),
        id: (0, _get3.default)(data, 'name.id'),
        name: (0, _get3.default)(data, 'name.name')
      });
    }
  }, {
    key: 'onChangeCategory',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(categoryVal) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isLoading = true;
                this.formManager.onChange.category(categoryVal);
                this.formManager.onChange.name(null);
                this.formManager.addNewUndo(this.FIELD_SETS_FIELD_NAME);
                this.onChange();
                this.isLoading = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onChangeCategory(_x2) {
        return _ref2.apply(this, arguments);
      }

      return onChangeCategory;
    }()
  }, {
    key: 'onChangeName',
    value: function onChangeName(nameVal) {
      this.formManager.onChange.name(nameVal);
      this.onChange();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_mightyFields.FormFieldSets, _extends({
          fieldSets: this.fieldSets
        }, this.formManager.formGroupsProps, {
          onChange: {
            'category': this.onChangeCategory,
            'name': this.onChangeName
          }
        }))
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'fieldSets',
    get: function get() {
      var fieldSet = [_extends({}, this.FIELD_SETS_FIELD_CATEGORY, {
        disabled: this.isLoading,
        required: this.props.required
      })];

      if (this.formManager.submitData.category) {
        fieldSet.push(_extends({}, this.FIELD_SETS_FIELD_NAME, {
          disabled: this.isLoading
        }));
      }

      return [fieldSet];
    }
  }]);

  return LeadSourceFormGroup;
}(_react.Component), _class3.defaultProps = {
  required: false
}, _class3.propTypes = {
  leadSource: _propTypes2.default.object,
  onChange: _propTypes2.default.func.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  required: _propTypes2.default.bool
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = LeadSourceFormGroup;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LeadSourceFormGroup, 'LeadSourceFormGroup', '/app/src/components/page-case/LeadSourceFormGroup.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/LeadSourceFormGroup.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9MZWFkU291cmNlRm9ybUdyb3VwLmpzIl0sIm5hbWVzIjpbIkxlYWRTb3VyY2VGb3JtR3JvdXAiLCJhdXRvQmluZE1ldGhvZHMiLCJvYnNlcnZlciIsInByb3BzIiwiRklFTERfU0VUU19GSUVMRF9DQVRFR09SWSIsImZpZWxkIiwib3B0aW9uS2V5Iiwib3B0aW9uVHlwZSIsInR5cGUiLCJGSUVMRF9TRVRTX0ZJRUxEX05BTUUiLCJjcmVhdGVGaWVsZHMiLCJwb3B1bGF0ZUZyb21TZWFyY2giLCJyZXF1aXJlZCIsImVkaXRQcm9wcyIsInZhbGlkYXRpb25FcnJvcnMiLCJpc1JlcXVpcmVkRm9yIiwidmFsaWRhdGlvbnMiLCJnZXRPcHRpb25zIiwiZ2V0TGVhZFNvdXJjZU9wdGlvbnMiLCJsYWJlbCIsImZvcm1NYW5hZ2VyIiwiRm9ybU1hbmFnZXIiLCJmaWVsZFNldHMiLCJsZWFkU291cmNlIiwiY2F0ZWdvcnkiLCJpZCIsIm5hbWUiLCJvbkNoYW5nZUNhdGVnb3J5Iiwib25DaGFuZ2VOYW1lIiwic2VhcmNoIiwiZmV0Y2hMZWFkU291cmNlTmFtZU9wdGlvbnMiLCJPcHRpb25zU3RvcmUiLCJzdWJtaXREYXRhIiwiZGF0YSIsIm9uQ2hhbmdlIiwiY2F0ZWdvcnlWYWwiLCJpc0xvYWRpbmciLCJhZGROZXdVbmRvIiwibmFtZVZhbCIsImZvcm1Hcm91cHNQcm9wcyIsImZpZWxkU2V0IiwiZGlzYWJsZWQiLCJwdXNoIiwiQ29tcG9uZW50IiwiZGVmYXVsdFByb3BzIiwicHJvcFR5cGVzIiwiUHJvcFR5cGVzIiwib2JqZWN0IiwiZnVuYyIsImlzUmVxdWlyZWQiLCJib29sIiwib2JzZXJ2YWJsZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7QUFDQTs7OztBQUdBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lBS01BLG1CLFdBSEwsdUJBQU8sY0FBUCxDLG9CQUNBQyxnQyxlQUNBQyxtQjs7O0FBSUMsK0JBQWFDLEtBQWIsRUFBb0I7QUFBQTs7QUFBQSwwSUFDWkEsS0FEWTs7QUFBQTs7QUFHbEIsVUFBS0MseUJBQUwsR0FBaUM7QUFDL0JDLGFBQU8sVUFEd0I7QUFFL0JDLGlCQUFXLE9BRm9CO0FBRy9CQyxrQkFBWSwyQkFIbUI7QUFJL0JDLFlBQU07QUFKeUIsS0FBakM7O0FBT0EsVUFBS0MscUJBQUwsR0FBNkI7QUFDM0JDLG9CQUFjLENBQUMsRUFBRUwsT0FBTyxNQUFULEVBQWlCTSxvQkFBb0IsSUFBckMsRUFBMkNDLFVBQVUsSUFBckQsRUFBRCxDQURhO0FBRTNCQyxpQkFBVztBQUNUQywwQkFBa0IsRUFBRUMsZUFBZSwwQkFBakIsRUFEVDtBQUVUQyxxQkFBYSxFQUFFRCxlQUFlLFVBQWpCO0FBRkosT0FGZ0I7QUFNM0JWLGFBQU8sTUFOb0I7QUFPM0JZLGtCQUFZLE1BQUtDLG9CQVBVO0FBUTNCQyxhQUFPLGFBUm9CO0FBUzNCWCxZQUFNO0FBVHFCLEtBQTdCOztBQVlBLFVBQUtZLFdBQUwsR0FBbUIsSUFBSUMsa0JBQUosQ0FBZ0I7QUFDakNDLGlCQUFXLENBQUMsQ0FDVixNQUFLbEIseUJBREssRUFFVixNQUFLSyxxQkFGSyxDQUFEO0FBRHNCLEtBQWhCLENBQW5COztBQU9BLFFBQUlOLE1BQU1vQixVQUFWLEVBQXNCO0FBQUEsOEJBS2hCcEIsTUFBTW9CLFVBTFU7QUFBQSxVQUVsQkMsUUFGa0IscUJBRWxCQSxRQUZrQjtBQUFBLFVBR2xCQyxFQUhrQixxQkFHbEJBLEVBSGtCO0FBQUEsVUFJbEJDLElBSmtCLHFCQUlsQkEsSUFKa0I7OztBQU9wQixZQUFLQyxnQkFBTCxDQUFzQkgsUUFBdEI7QUFDQSxZQUFLSSxZQUFMLENBQWtCLEVBQUVILE1BQUYsRUFBTUMsVUFBTixFQUFsQjtBQUNEO0FBdENpQjtBQXVDbkI7Ozs7OzBGQUUyQkcsTTs7Ozs7O0FBQ0ZDLDBDLEdBQWlDLEtBQUszQixLLENBQXRENEIsWSxDQUFnQkQsMEIsRUFDcEJOLFEsR0FBVyxLQUFLSixXQUFMLENBQWlCWSxVQUFqQixDQUE0QlIsUTs7dUJBRTdCTSwyQkFBMkJOLFFBQTNCLEVBQXFDSyxNQUFyQyxDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7K0JBR0o7QUFDVixVQUFNSSxPQUFPLEtBQUtiLFdBQUwsQ0FBaUJZLFVBQTlCO0FBQ0EsV0FBSzdCLEtBQUwsQ0FBVytCLFFBQVgsQ0FBb0I7QUFDbEJWLGtCQUFVLG1CQUFJUyxJQUFKLEVBQVUsVUFBVixDQURRO0FBRWxCUixZQUFJLG1CQUFJUSxJQUFKLEVBQVUsU0FBVixDQUZjO0FBR2xCUCxjQUFNLG1CQUFJTyxJQUFKLEVBQVUsV0FBVjtBQUhZLE9BQXBCO0FBS0Q7Ozs7NEZBRXVCRSxXOzs7OztBQUN0QixxQkFBS0MsU0FBTCxHQUFpQixJQUFqQjtBQUNBLHFCQUFLaEIsV0FBTCxDQUFpQmMsUUFBakIsQ0FBMEJWLFFBQTFCLENBQW1DVyxXQUFuQztBQUNBLHFCQUFLZixXQUFMLENBQWlCYyxRQUFqQixDQUEwQlIsSUFBMUIsQ0FBK0IsSUFBL0I7QUFDQSxxQkFBS04sV0FBTCxDQUFpQmlCLFVBQWpCLENBQTRCLEtBQUs1QixxQkFBakM7QUFDQSxxQkFBS3lCLFFBQUw7QUFDQSxxQkFBS0UsU0FBTCxHQUFpQixLQUFqQjs7Ozs7Ozs7Ozs7Ozs7Ozs7O2lDQUdZRSxPLEVBQVM7QUFDckIsV0FBS2xCLFdBQUwsQ0FBaUJjLFFBQWpCLENBQTBCUixJQUExQixDQUErQlksT0FBL0I7QUFDQSxXQUFLSixRQUFMO0FBQ0Q7Ozs2QkFtQlM7QUFDUixhQUNFO0FBQUE7QUFBQTtBQUNFLHNDQUFDLDJCQUFEO0FBQ0UscUJBQVcsS0FBS1o7QUFEbEIsV0FFTSxLQUFLRixXQUFMLENBQWlCbUIsZUFGdkI7QUFHRSxvQkFBVTtBQUNSLHdCQUFZLEtBQUtaLGdCQURUO0FBRVIsb0JBQVEsS0FBS0M7QUFGTDtBQUhaO0FBREYsT0FERjtBQVlEOzs7Ozs7Ozs7O3dCQTlCZ0I7QUFDZixVQUFNWSxXQUFXLGNBQ1osS0FBS3BDLHlCQURPO0FBRWZxQyxrQkFBVSxLQUFLTCxTQUZBO0FBR2Z4QixrQkFBVSxLQUFLVCxLQUFMLENBQVdTO0FBSE4sU0FBakI7O0FBTUEsVUFBSSxLQUFLUSxXQUFMLENBQWlCWSxVQUFqQixDQUE0QlIsUUFBaEMsRUFBMEM7QUFDeENnQixpQkFBU0UsSUFBVCxjQUNLLEtBQUtqQyxxQkFEVjtBQUVFZ0Msb0JBQVUsS0FBS0w7QUFGakI7QUFJRDs7QUFFRCxhQUFPLENBQUNJLFFBQUQsQ0FBUDtBQUNEOzs7O0VBekYrQkcsZ0IsV0EwR3pCQyxZLEdBQWU7QUFDcEJoQyxZQUFVO0FBRFUsQyxVQUlmaUMsUyxHQUFZO0FBQ2pCdEIsY0FBWXVCLG9CQUFVQyxNQURMO0FBRWpCYixZQUFVWSxvQkFBVUUsSUFBVixDQUFlQyxVQUZSO0FBR2pCbEIsZ0JBQWNlLG9CQUFVQyxNQUFWLENBQWlCRSxVQUhkO0FBSWpCckMsWUFBVWtDLG9CQUFVSTtBQUpILEMsb0ZBN0dsQkMsZ0I7OztXQUF1QixLOzs7ZUFxSFhuRCxtQjs7Ozs7Ozs7Ozs7MEJBdEhUQSxtQiIsImZpbGUiOiJMZWFkU291cmNlRm9ybUdyb3VwLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IG9ic2VydmFibGUgfSBmcm9tICdtb2J4JztcbmltcG9ydCB7IG9ic2VydmVyLCBpbmplY3QgfSBmcm9tICdtb2J4LXJlYWN0JztcbmltcG9ydCBhdXRvQmluZE1ldGhvZHMgZnJvbSAnY2xhc3MtYXV0b2JpbmQtZGVjb3JhdG9yJztcbmltcG9ydCB7IGdldCB9IGZyb20gJ2xvZGFzaCc7XG5cbmltcG9ydCB7IEZvcm1GaWVsZFNldHMgfSBmcm9tICcuLi8uLi9saWIvbWlnaHR5LWZpZWxkcyc7XG5pbXBvcnQgeyBGb3JtTWFuYWdlciB9IGZyb20gJy4uLy4uL3V0aWxzJztcblxuQGluamVjdCgnT3B0aW9uc1N0b3JlJylcbkBhdXRvQmluZE1ldGhvZHNcbkBvYnNlcnZlclxuY2xhc3MgTGVhZFNvdXJjZUZvcm1Hcm91cCBleHRlbmRzIENvbXBvbmVudCB7XG4gIEBvYnNlcnZhYmxlIGlzTG9hZGluZyA9IGZhbHNlO1xuXG4gIGNvbnN0cnVjdG9yIChwcm9wcykge1xuICAgIHN1cGVyKHByb3BzKTtcblxuICAgIHRoaXMuRklFTERfU0VUU19GSUVMRF9DQVRFR09SWSA9IHtcbiAgICAgIGZpZWxkOiAnY2F0ZWdvcnknLFxuICAgICAgb3B0aW9uS2V5OiAndmFsdWUnLFxuICAgICAgb3B0aW9uVHlwZTogJ2xlYWRTb3VyY2VDYXRlZ29yeU9wdGlvbnMnLFxuICAgICAgdHlwZTogJ29wdGlvblNlbGVjdCcsXG4gICAgfTtcblxuICAgIHRoaXMuRklFTERfU0VUU19GSUVMRF9OQU1FID0ge1xuICAgICAgY3JlYXRlRmllbGRzOiBbeyBmaWVsZDogJ25hbWUnLCBwb3B1bGF0ZUZyb21TZWFyY2g6IHRydWUsIHJlcXVpcmVkOiB0cnVlIH1dLFxuICAgICAgZWRpdFByb3BzOiB7XG4gICAgICAgIHZhbGlkYXRpb25FcnJvcnM6IHsgaXNSZXF1aXJlZEZvcjogJ0xlYWQgU291cmNlIGlzIHJlcXVpcmVkLicgfSxcbiAgICAgICAgdmFsaWRhdGlvbnM6IHsgaXNSZXF1aXJlZEZvcjogJ2NhdGVnb3J5JyB9LFxuICAgICAgfSxcbiAgICAgIGZpZWxkOiAnbmFtZScsXG4gICAgICBnZXRPcHRpb25zOiB0aGlzLmdldExlYWRTb3VyY2VPcHRpb25zLFxuICAgICAgbGFiZWw6ICdMZWFkIFNvdXJjZScsXG4gICAgICB0eXBlOiAnb2JqZWN0U2VhcmNoQ3JlYXRlJyxcbiAgICB9O1xuXG4gICAgdGhpcy5mb3JtTWFuYWdlciA9IG5ldyBGb3JtTWFuYWdlcih7XG4gICAgICBmaWVsZFNldHM6IFtbXG4gICAgICAgIHRoaXMuRklFTERfU0VUU19GSUVMRF9DQVRFR09SWSxcbiAgICAgICAgdGhpcy5GSUVMRF9TRVRTX0ZJRUxEX05BTUUsXG4gICAgICBdXSxcbiAgICB9KTtcblxuICAgIGlmIChwcm9wcy5sZWFkU291cmNlKSB7XG4gICAgICBjb25zdCB7XG4gICAgICAgIGNhdGVnb3J5LFxuICAgICAgICBpZCxcbiAgICAgICAgbmFtZSxcbiAgICAgIH0gPSBwcm9wcy5sZWFkU291cmNlO1xuXG4gICAgICB0aGlzLm9uQ2hhbmdlQ2F0ZWdvcnkoY2F0ZWdvcnkpO1xuICAgICAgdGhpcy5vbkNoYW5nZU5hbWUoeyBpZCwgbmFtZSB9KTtcbiAgICB9XG4gIH1cblxuICBhc3luYyBnZXRMZWFkU291cmNlT3B0aW9ucyAoc2VhcmNoKSB7XG4gICAgY29uc3QgeyBPcHRpb25zU3RvcmU6IHsgZmV0Y2hMZWFkU291cmNlTmFtZU9wdGlvbnMgfSB9ID0gdGhpcy5wcm9wc1xuICAgICAgLCBjYXRlZ29yeSA9IHRoaXMuZm9ybU1hbmFnZXIuc3VibWl0RGF0YS5jYXRlZ29yeTtcblxuICAgIHJldHVybiAoYXdhaXQgZmV0Y2hMZWFkU291cmNlTmFtZU9wdGlvbnMoY2F0ZWdvcnksIHNlYXJjaCkpO1xuICB9XG5cbiAgb25DaGFuZ2UgKCkge1xuICAgIGNvbnN0IGRhdGEgPSB0aGlzLmZvcm1NYW5hZ2VyLnN1Ym1pdERhdGE7XG4gICAgdGhpcy5wcm9wcy5vbkNoYW5nZSh7XG4gICAgICBjYXRlZ29yeTogZ2V0KGRhdGEsICdjYXRlZ29yeScpLFxuICAgICAgaWQ6IGdldChkYXRhLCAnbmFtZS5pZCcpLFxuICAgICAgbmFtZTogZ2V0KGRhdGEsICduYW1lLm5hbWUnKSxcbiAgICB9KTtcbiAgfVxuXG4gIGFzeW5jIG9uQ2hhbmdlQ2F0ZWdvcnkgKGNhdGVnb3J5VmFsKSB7XG4gICAgdGhpcy5pc0xvYWRpbmcgPSB0cnVlO1xuICAgIHRoaXMuZm9ybU1hbmFnZXIub25DaGFuZ2UuY2F0ZWdvcnkoY2F0ZWdvcnlWYWwpO1xuICAgIHRoaXMuZm9ybU1hbmFnZXIub25DaGFuZ2UubmFtZShudWxsKTtcbiAgICB0aGlzLmZvcm1NYW5hZ2VyLmFkZE5ld1VuZG8odGhpcy5GSUVMRF9TRVRTX0ZJRUxEX05BTUUpO1xuICAgIHRoaXMub25DaGFuZ2UoKTtcbiAgICB0aGlzLmlzTG9hZGluZyA9IGZhbHNlO1xuICB9XG5cbiAgb25DaGFuZ2VOYW1lIChuYW1lVmFsKSB7XG4gICAgdGhpcy5mb3JtTWFuYWdlci5vbkNoYW5nZS5uYW1lKG5hbWVWYWwpO1xuICAgIHRoaXMub25DaGFuZ2UoKTtcbiAgfVxuXG4gIGdldCBmaWVsZFNldHMgKCkge1xuICAgIGNvbnN0IGZpZWxkU2V0ID0gW3tcbiAgICAgIC4uLnRoaXMuRklFTERfU0VUU19GSUVMRF9DQVRFR09SWSxcbiAgICAgIGRpc2FibGVkOiB0aGlzLmlzTG9hZGluZyxcbiAgICAgIHJlcXVpcmVkOiB0aGlzLnByb3BzLnJlcXVpcmVkLFxuICAgIH1dO1xuXG4gICAgaWYgKHRoaXMuZm9ybU1hbmFnZXIuc3VibWl0RGF0YS5jYXRlZ29yeSkge1xuICAgICAgZmllbGRTZXQucHVzaCh7XG4gICAgICAgIC4uLnRoaXMuRklFTERfU0VUU19GSUVMRF9OQU1FLFxuICAgICAgICBkaXNhYmxlZDogdGhpcy5pc0xvYWRpbmcsXG4gICAgICB9KTtcbiAgICB9XG5cbiAgICByZXR1cm4gW2ZpZWxkU2V0XTtcbiAgfVxuXG4gIHJlbmRlciAoKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXY+XG4gICAgICAgIDxGb3JtRmllbGRTZXRzXG4gICAgICAgICAgZmllbGRTZXRzPXt0aGlzLmZpZWxkU2V0c31cbiAgICAgICAgICB7Li4udGhpcy5mb3JtTWFuYWdlci5mb3JtR3JvdXBzUHJvcHN9XG4gICAgICAgICAgb25DaGFuZ2U9e3tcbiAgICAgICAgICAgICdjYXRlZ29yeSc6IHRoaXMub25DaGFuZ2VDYXRlZ29yeSxcbiAgICAgICAgICAgICduYW1lJzogdGhpcy5vbkNoYW5nZU5hbWUsXG4gICAgICAgICAgfX1cbiAgICAgICAgLz5cbiAgICAgIDwvZGl2PlxuICAgICk7XG4gIH1cblxuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIHJlcXVpcmVkOiBmYWxzZSxcbiAgfVxuXG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgbGVhZFNvdXJjZTogUHJvcFR5cGVzLm9iamVjdCxcbiAgICBvbkNoYW5nZTogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgICBPcHRpb25zU3RvcmU6IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgICByZXF1aXJlZDogUHJvcFR5cGVzLmJvb2wsXG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IExlYWRTb3VyY2VGb3JtR3JvdXA7XG4iXX0=